/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ allocated: NonNullable<unknown>, total: NonNullable<unknown>, unit: NonNullable<unknown> }} Stock_Out_Dialog_AllocatedInputs */

const vi_stock_out_dialog_allocated = /** @type {(inputs: Stock_Out_Dialog_AllocatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đã phân bổ ${i?.allocated}/${i?.total} ${i?.unit}`)
};

/**

* @param {Stock_Out_Dialog_AllocatedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stock_out_dialog_allocated = /** @type {((inputs: Stock_Out_Dialog_AllocatedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stock_Out_Dialog_AllocatedInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stock_out_dialog_allocated(inputs)
});